import Rarity from "types/Rarity";

const skills = {
  [Rarity.UR]: [5, 11.25, 18.75, 30, 50],
  [Rarity.SSR]: [4, 9, 15, 24, 40],
  [Rarity.SR]: [3, 6.75, 11.25, 18, 30],
  [Rarity.R]: [2, 4.5, 7.5, 12, 20],
  [Rarity.N]: [1, 2.25, 3.75, 6, 10],
};

const resolve = [8, 18, 30, 48, 80];

const bonusTeam = 50;

const rarities = {
  [Rarity.UR]: 5,
  [Rarity.SSR]: 4,
  [Rarity.SR]: 3,
  [Rarity.R]: 2,
  [Rarity.N]: 1,
};

const comboEvent = 20;

const statSynergy = 100;

const RATINGS = {
  skills,
  resolve,
  bonusTeam,
  rarities,
  comboEvent,
  statSynergy,
};

export type RatingConfig = Partial<typeof RATINGS>;

export default RATINGS;
